import R from 'ramda';
import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import { Component } from 'react';
import PropTypes from 'prop-types';

import TextInput from '../TextInput';
import CourseList from '../CourseList';
import Loading from '../Loading';
import styles from './search.css';

const { div, form, p } = hh(h);

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: ''
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({query: event.target.value});
    }

    render() {
        const props = this.props;
        const { data: { loading, courses } } = props;

        if (loading) return h(Loading, { center: true });

        const formElement = (
            form({className: styles.form}, [
                p({className: styles.helpText}, this.props.helpText),
                h(TextInput, {placeholder: this.props.placeholder, size: 'large', onChange: this.handleChange, type: 'text'})])
        );

        const searchWithoutList = div({className: styles.container}, formElement);

        const searchWithList = (
            div({className: styles.container}, [
                formElement,
                h(CourseList, {query: this.state.query, courses})])
        );

        return R.isEmpty(this.state.query) ? searchWithoutList : searchWithList;
    }
}

Search.propTypes = {
    placeholder: PropTypes.string.isRequired,
    helpText: PropTypes.string
};

export default Search;



/** WEBPACK FOOTER **
 ** ./src/Search/index.js
 **/